import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=06d92feb&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d92feb')) {
      api.createRecord('06d92feb', component.options)
    } else {
      api.reload('06d92feb', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=06d92feb&", function () {
      api.rerender('06d92feb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/Index.vue"
export default component.exports